import { CheckCircle2, Copy, Home as HomeIcon, Sofa, Leaf } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { toast } from "sonner";

export default function Step5Confirm({ data, ticket }) {
  const isEnseres = data.tipo_servicio === "enseres";

  const copyTicket = () => {
    navigator.clipboard.writeText(ticket);
    toast.success("Código copiado al portapapeles");
  };

  return (
    <div className="text-center py-6" data-testid="wizard-confirmation">
      <div className="w-20 h-20 rounded-full bg-valoriza-green/10 flex items-center justify-center mx-auto mb-6">
        <CheckCircle2 className="w-10 h-10 text-valoriza-green" />
      </div>
      <h2 className="font-heading font-bold text-2xl sm:text-3xl text-municipal mb-3">¡Solicitud registrada!</h2>
      <p className="text-gray-500 max-w-md mx-auto mb-8">
        Hemos recibido tu solicitud de {isEnseres ? "recogida de enseres" : "recogida de poda"}.
        Guarda este código para consultar el estado en cualquier momento.
      </p>

      <div className="inline-flex items-center gap-3 bg-municipal/5 border-2 border-dashed border-municipal/30 rounded-xl px-6 py-4 mb-8">
        <span className="font-heading font-bold text-xl text-municipal tracking-wide" data-testid="wizard-ticket-code">
          {ticket}
        </span>
        <button onClick={copyTicket} className="text-municipal hover:text-dorado">
          <Copy className="w-5 h-5" />
        </button>
      </div>

      <div className="bg-gray-50 rounded-xl p-5 max-w-md mx-auto text-left mb-10 text-sm space-y-2">
        <p className="flex items-center gap-2 text-gray-600">
          {isEnseres ? <Sofa className="w-4 h-4 text-municipal" /> : <Leaf className="w-4 h-4 text-valoriza-green" />}
          Servicio: <strong className="text-municipal">{isEnseres ? "Enseres" : "Poda"}</strong>
        </p>
        <p className="text-gray-600">Fecha preferida: <strong className="text-municipal">{data.fecha_preferida}</strong></p>
        <p className="text-gray-600">Dirección: <strong className="text-municipal">{data.direccion_completa}</strong></p>
        <p className="text-gray-600">Isla de contenedores: <strong className="text-municipal">{data.isla_contenedores}</strong></p>
      </div>

      <p className="text-xs text-gray-400 mb-8 max-w-md mx-auto">
        Te hemos enviado un correo de confirmación con estos detalles. Recuerda: deposita los
        elementos junto a la isla de contenedores indicada, nunca en la puerta de tu domicilio, y
        a partir de las 19:00h del día anterior a la recogida.
      </p>

      <Link to="/">
        <Button variant="outline" className="border-municipal text-municipal">
          <HomeIcon className="w-4 h-4 mr-2" /> Volver al inicio
        </Button>
      </Link>
    </div>
  );
}
